"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _assets = require("../assets");

var _antd = require("antd");

var _components = require("./components");

var _awsAmplify = require("aws-amplify");

var _IndexModule = _interopRequireDefault(require("./Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function LoginScreen(_ref) {
  var label = _ref.label,
      cardStyle = _ref.cardStyle,
      contentStyle = _ref.contentStyle,
      history = _ref.history,
      path = _ref.path;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      userName = _useState2[0],
      setUserName = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1]; // eslint-disable-next-line no-unused-vars


  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      newPassword = _useState6[0],
      setNewPassword = _useState6[1]; // eslint-disable-next-line no-unused-vars


  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      confirmNewPassword = _useState8[0],
      setConfirmNewPassword = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      completePasswordForm = _useState10[0],
      setCompletePasswordForm = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      activeResetPassword = _useState12[0],
      setActiveResetPassword = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      loading = _useState14[0],
      setLoading = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = _slicedToArray(_useState15, 2),
      errorMessage = _useState16[0],
      setErrorMessage = _useState16[1];

  (0, _react.useEffect)(function () {
    _awsAmplify.Auth.currentSession().then(function (data) {
      console.log(data);
      return history.push(path);
    })["catch"](function (err) {
      console.log(err);
    });
  }, [history]);

  var onFinish = function onFinish() {
    setErrorMessage("");
    setLoading(true);
    console.log(userName);

    _awsAmplify.Auth.signIn(userName, password).then(function (user) {
      console.log(user);

      if (user.challengeName === "NEW_PASSWORD_REQUIRED" && !completePasswordForm) {
        setLoading(false);
        setCompletePasswordForm(true);
      } else if (user.challengeName === "NEW_PASSWORD_REQUIRED" && completePasswordForm) _awsAmplify.Auth.completeNewPassword(user, newPassword).then(function (res) {
        history.push(path);
      })["catch"](function (err) {
        _antd.message.info("Hubo un error, inténtelo de nuevo. Recuerda que las contraseñas son mínimo 10 caracteres");

        setLoading(false);
      });else if (user.challengeName === "NEW_PASSWORD_REQUIRED" && activeResetPassword) {
        console.log("Reset ?");

        _awsAmplify.Auth.forgotPassword(user).then(function (data) {
          alert("wena");
          console.log(data);
        })["catch"](function (err) {
          alert("eppa");
          console.log(err);
        });
      } else history.push(path);
    })["catch"](function (err) {
      if (err.code === "NotAuthorizedException") _antd.message.info("Hubo un error, el usuario y/o contraseña no son correctos. Inténtelo de nuevo");else if (err.code === "UserNotFoundException") _antd.message.info("Hubo un error, usuario no existe. Inténtelo de nuevo");else _antd.message.info("Hubo un error. Inténtelo de nuevo");
      setErrorMessage(err.message);
      setLoading(false);
    });
  };

  var onFinishFailed = function onFinishFailed() {
    _antd.message.info("Hubo un error, inténtelo de nuevo.");
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginCard,
    style: cardStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginHeader
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginLogo
  }, /*#__PURE__*/_react["default"].createElement(_assets.Logo, {
    width: "200px"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginTitle
  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginContent,
    style: contentStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].loginContentData
  }, !completePasswordForm ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !activeResetPassword ? /*#__PURE__*/_react["default"].createElement(_components.LoginUser, {
    activeResetPassword: activeResetPassword,
    loading: loading,
    errorMessage: errorMessage,
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    setUserName: setUserName,
    setPassword: setPassword,
    setActiveResetPassword: setActiveResetPassword,
    setLoading: setLoading
  }) : /*#__PURE__*/_react["default"].createElement(_components.RestorePassword, {
    loading: loading,
    setActiveResetPassword: setActiveResetPassword,
    userName: userName,
    setUserName: setUserName,
    setLoading: setLoading
  })) : /*#__PURE__*/_react["default"].createElement(_components.NewPassword, {
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    userName: userName,
    loading: loading,
    setConfirmNewPassword: setConfirmNewPassword,
    setUserName: setUserName,
    setNewPassword: setNewPassword
  })))));
}

var _default = LoginScreen;
exports["default"] = _default;